/**
 * ProposalSectionEditor.tsx — authors spec.proposalSection.html (the calc-owned
 * proposal section, D4). Rendered verbatim by proposal-builder for this calc's
 * category. Rich HTML + chip palette derived from the live config.
 */

import HtmlChipEditor from './HtmlChipEditor';
import { StudioPanel } from './ui';
import type { CalcSpec, StudioInputField } from '../../../api/calculatorBuilder';

interface Props {
  spec: CalcSpec;
  inputs: StudioInputField[];
  css?: string;
  onChange: (html: string) => void;
}

export default function ProposalSectionEditor({ spec, inputs, css, onChange }: Props) {
  return (
    <StudioPanel
      title="Proposal section"
      subtitle="Single source for this calc's proposal section. Proposal-builder shows it read-only with an ‘Edit in Calculator Studio’ link."
    >
      <HtmlChipEditor
        html={spec.proposalSection?.html ?? ''}
        spec={spec}
        inputs={inputs}
        css={css}
        tall
        onChange={onChange}
      />
    </StudioPanel>
  );
}
